import { WineOfferStatusCode } from 'utils/consts/wineOffer'
import { Product } from 'api/schemas'

const recognitionStatuses = [
  WineOfferStatusCode.OfferRecognition,
  WineOfferStatusCode.DraftRecognition,
  WineOfferStatusCode.AcceptedRecognition,
  WineOfferStatusCode.ExpiredRecognition,
]

const recognitionErrorStatuses = [
  WineOfferStatusCode.OfferRecognitionError,
  WineOfferStatusCode.DraftRecognitionError,
  WineOfferStatusCode.AcceptedRecognitionError,
  WineOfferStatusCode.ExpiredRecognitionError,
]

interface UseRecognitionStatusParams {
  product: Product | null | undefined
  statusCode: WineOfferStatusCode
}

interface UseRecognitionStatusResult {
  showManualRecognition: boolean
  showRetakeNeeded: boolean
}

export const useRecognitionStatus = ({
  product,
  statusCode,
}: UseRecognitionStatusParams): UseRecognitionStatusResult => {
  const showManualRecognition =
    !product && recognitionStatuses.includes(statusCode)
  const showRetakeNeeded =
    !product && recognitionErrorStatuses.includes(statusCode)

  return {
    showManualRecognition,
    showRetakeNeeded,
  }
}
